import { FC } from "react";
import Text from "../../../../../components/Text";
import Stat from "../../../../../components/Text/Stat";
import styles from "./StatsValidatingCell.module.scss";

interface StatsValidatingCellProps {
    weekNumber: number;
    weeklyTotal?: number;
    className?: string;
}

const StatsValidatingCell: FC<StatsValidatingCellProps> = ({
    weekNumber,
    weeklyTotal = 0,
    className,
}) => {
    return (
        <div className={`${styles.validatingCell} ${className || ""}`.trim()}>
            <div className={styles.validatingCellContent}>
                <Text variant="body-bold" className={styles.weekNumber}>
                    <span>{`S`}</span>
                    <span className={styles.weekLabel}>{`emaine `}</span>
                    {weekNumber}
                </Text>
                {weeklyTotal !== undefined && (
                    <Stat type="currency" variant="body-bold">
                        {weeklyTotal}
                    </Stat>
                )}
            </div>
        </div>
    );
};

export default StatsValidatingCell;
